<script lang="ts">import Link from '../../Link/Link.svelte';
import { getLoggedIn, getCartCount } from '../../../../../js-v2/stores/user-state-stores';
import { getComponentType } from '../../../../../js-v2/componentUtils';
import { filterNavItems } from '../../../../../js-v2/navItemFilters';
const { navItems = [], cartPrimary = false, listStartingIndex = 0, slideInFrom = 'top' } = $props();
const cartCountStore = getCartCount();
const loggedInStore = getLoggedIn();
const marginTop = $derived(!cartPrimary);
const filteredItems = $derived(filterNavItems({
    items: navItems,
    loggedIn: $loggedInStore,
    cartCount: $cartCountStore,
}));
</script>

<ul class="ItemList slide-in-from-{slideInFrom}" class:marginTop>
  {#each filteredItems as item, index}
    {#if getComponentType(item.componentName) === 'link'}
      {#if item?.props?.linkStyle === 'primary' || item?.props?.linkStyle === 'secondary'}
        <li class="button-item" style:--item-list-item-number={listStartingIndex + index + 1}>
          <Link
            id={item?.contentfulEntryId}
            title={item?.props?.title}
            url={item?.props?.url}
            linkStyle={item?.props?.linkStyle}
            openInNewTab={item?.props?.openInNewTab}
          />
        </li>
      {:else}
        <li class="link-item" class:hidden={item.hidden} style:--item-list-item-number={listStartingIndex + index + 1}>
          <Link
            linkCustomCssClass="item-list-link"
            id={item?.contentfulEntryId}
            title={item?.props?.title}
            url={item?.props?.url}
            linkStyle={item?.props?.linkStyle}
            enableHoverOpacity={true}
            openInNewTab={item?.props?.openInNewTab}
          />
        </li>
      {/if}
    {/if}
  {/each}
</ul>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.ItemList {
  display: block;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  list-style-type: none;
  position: relative;
  display: block;
}
.ItemList > li {
  display: block;
  position: static;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.ItemList > li::before {
  display: none;
}
.ItemList > li :global(:last-child) {
  margin: 0;
}
.ItemList .button-item {
  max-width: 280px;
}
.ItemList .button-item:first-child {
  margin-top: 25px;
}

.marginTop {
  margin-top: 25px;
}</style>
